// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/_vue-style-loader@3.1.2@vue-style-loader!./~/_css-loader@0.28.11@css-loader?{"minimize":true,"sourceMap":true}!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-565f9002","scoped":true,"hasInlineConfig":false}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/pages/login.vue
// module id = VRwx
// module chunks = 1 2 3